import React, { useEffect, useState } from "react";

import { BigPicture } from "../../../helper";

import "../../../assets/stlyes/BigPicture/Progress.scss";

const ProgressMainTable = (props) => {
  const { subject, listView, setStudentDetails } = props;
  const [fixedHeaders, setFixedHeaders] = useState([]);
  const [regularHeaders, setRegularHeaders] = useState([]);
  const [tableDatas, setTableDatas] = useState([]);

  const convertDataArrayToObjectArray = (studentDetails) => {
    const convertedObject = [
      { key: BigPicture.ProgressInputKeys.Unknown, values: [] },
      { key: BigPicture.ProgressInputKeys.NotOnTrack, values: [] },
      { key: BigPicture.ProgressInputKeys.Ontrack, values: [] },
      { key: BigPicture.ProgressInputKeys.Exceeding, values: [] }
    ];
  
    studentDetails.forEach(data => {
      convertedObject.forEach((item,) => {
        const percent = data.value[item.key].percent;
        const number = data.value[item.key].number;
        const pupil = data.value[item.key].pupil;
        item.values.push({ percent, number, pupil });
      });
    });
  
    return convertedObject.map(item => [
      item.key,
      ...item.values.map(entry => ({
        percent: entry.percent,
        number: entry.number,
        pupil: entry.pupil
      }))
    ]).reverse();
  }
  
  useEffect(() => {
    const firstSubjectData = Object.values(subject)[0];
    setTableDatas(convertDataArrayToObjectArray(firstSubjectData));
    setFixedHeaders([BigPicture.ProgressOutputKeys.KeyInsights]);
    setRegularHeaders(firstSubjectData.map(item => `${item.name} (${item.totalCount})`));
  }, [subject]);

  const addTd = (arr) => {
    return arr.map((e, index) => <td key={index}>{e}</td>);
  };

  const renderFrozen = () => {
    return (
      <tbody>
        <tr><td>{BigPicture.ProgressOutputKeys.Exceeding}</td></tr>
        <tr><td>{BigPicture.ProgressOutputKeys.Ontrack}</td></tr>
        <tr><td>{BigPicture.ProgressOutputKeys.NotOnTrack}</td></tr>
        <tr><td>{BigPicture.ProgressOutputKeys.Unknown}</td></tr>
      </tbody>
    );
  };

  const renderRegularTd = (arr, rowIndex, columnHeader) => {
    const sliceArr = arr.slice(fixedHeaders.length);
    return sliceArr.map((e, index) => (<td key={index} onClick={() => callNextFun(e.pupil, rowIndex, columnHeader[index])}>{`${e.percent} (${e.number})`}</td>));
  };

  const renderRegular = (arr) => {
    if (!Array.isArray(arr)) {
      return null;
    }
    return arr.map((e, index) => (
      <tr key={index}>{renderRegularTd(e, index, regularHeaders)}</tr>
    ));
  };

  const callNextFun = (e, rowIndex, selectedColumnHeader) => {
    const selectedValue = BigPicture.ProgressTableOutputKeys[rowIndex];
    setStudentDetails({ e, selectedValue, selectedColumnHeader: selectedColumnHeader?.replace(/\([^)]*\)/, "").trim() });
    listView(false);
  };

  return (
    <div className="progress-container">
      <div>
        <table className="fixed">
          <thead>
            <tr>{addTd(fixedHeaders)}</tr>
          </thead>
          {renderFrozen()}
        </table>
      </div>
      <div className="scroll">
        <table className="scrollable">
          <thead>
            <tr>{addTd(regularHeaders)}</tr>
          </thead>
          <tbody>{renderRegular(tableDatas)}</tbody>
        </table>
      </div>
    </div>
  );
};

export { ProgressMainTable };
